import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
var proxyNotSupportedInBrowser = new Error("ProxyPolicy is not supported in browser environment");
export function getDefaultProxySettings(_proxyUrl) {
  return undefined;
}
export function proxyPolicy(_proxySettings) {
  return {
    create: function create(_nextPolicy, _options) {
      throw proxyNotSupportedInBrowser;
    }
  };
}
export var ProxyPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(ProxyPolicy, _BaseRequestPolicy);

  var _super = _createSuper(ProxyPolicy);

  function ProxyPolicy(nextPolicy, options) {
    var _this;

    _classCallCheck(this, ProxyPolicy);

    _this = _super.call(this, nextPolicy, options);
    throw proxyNotSupportedInBrowser;
    return _this;
  }

  _createClass(ProxyPolicy, [{
    key: "sendRequest",
    value: function sendRequest(_request) {
      throw proxyNotSupportedInBrowser;
    }
  }]);

  return ProxyPolicy;
}(BaseRequestPolicy);